/** Which Settings → Templates tab a linked document came from. */
export enum SignerDocumentType {
  publicPage = 'publicPage',
  agreement = 'agreement',
}
